import { Input } from "antd";
import styled, { css } from "styled-components";

export const CommonInput = css`
  &.renderbus-ui--input {
    background: var(--topup-recharge-input);
    color: rgba(255, 255, 255, 0.85);
    border: 1px solid var(--topup-recharge-input-border);
    border-radius: 2px;
    font-size: 14px;
    &:focus {
      border-color: var(--main-color);
      box-shadow: none;
    }
    &:hover {
      border-color: var(--main-color);
    }
    &::placeholder {
      color: rgba(255, 255, 255, 0.65);
      font-size: 14px;
    }
    &.ant-input-status-error:not(.ant-input-disabled):not(
        .ant-input-borderless
      ).ant-input {
      background: var(--topup-recharge-input);
    }
    &.ant-input-affix-wrapper {
      background: var(--topup-recharge-input);
      border: 1px solid var(--topup-recharge-input-border);
      &.ant-input-affix-wrapper-focused {
        box-shadow: 0px 0px 0px 2px var(--color-main-alpha-022);
      }
      .ant-input {
        background: var(--topup-recharge-input);
        &::placeholder {
          color: rgba(255, 255, 255, 0.65);
        }
      }
      &:focus,
      &:hover {
        border: 1px solid var(--main-color);
        box-shadow: 0px 0px 0px 2px var(--color-main-alpha-022);
        border-radius: 4px;
      }
      .ant-input {
        margin-left: 10px;
        &::-webkit-inner-spin-button {
          -webkit-appearance: none;
        }
      }
    }
    &.ant-input-affix-wrapper-status-error:not(
        .ant-input-affix-wrapper-disabled
      ):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper {
      background: var(--topup-recharge-input);
    }
    &.addonafter {
      .ant-input {
        background-color: #2c2c31;
        border-color: transparent;
        font-size: 14px;
        &:focus {
          box-shadow: none;
        }
        &::placeholder {
          color: #b7b7b7;
        }
        &:hover {
          border: 1px solid var(--main-color);
        }
      }
      .ant-input-group-addon {
        color: rgba(255, 255, 255, 0.65);
        background-color: #414144;
        border-color: transparent;
      }
      &.ant-input-group-wrapper-status-error {
        .ant-input {
          background-color: #2c2c31 !important;
        }
        .ant-input-group-addon {
          color: rgba(255, 255, 255, 0.65);
        }
      }
      &:hover {
        border: 1px solid transparent;
      }
    }
    &.dingtalk_addonafter {
      border-color: #2c2c31;
      background-color: #2c2c31;
      color: #727e84;
      font-size: 14px;
      cursor: not-allowed;
      pointer-events: none;
      &:focus {
        box-shadow: none;
      }
    }
    &.dingtalk_222227 {
      background-color: #222227 !important;
      border-color: #222227 !important;
      margin: 0 12px 6px;
      width: 215px;
      .ant-input {
        background-color: #222227 !important;
        &::placeholder {
          color: #727e84;
          font-size: 12px;
        }
      }
      svg {
        color: #727e84;
      }
    }
    &.background-2C2C31 {
      background-color: var(--background-input-2c2c31) !important;
      .ant-input {
        background-color: var(--background-input-2c2c31) !important;
      }
    }
    &.background-191D1F {
      background-color: var(--background-input-191D1F) !important;
      .ant-input {
        background-color: var(--background-input-191D1F) !important;
      }
    }
    &.ant-input-disabled {
      color: #7e8486;
      border-color: transparent;
    }
  }
`;

export const StyledInput = styled(Input)`
  ${CommonInput};
`;
export const StyledTextArea = styled(Input.TextArea)`
  ${CommonInput};
`;
export const StyledPassword = styled(Input.Password)`
  ${CommonInput};
  svg {
    color: #fff;
  }
`;
